<template>
  <div>
    <a-modal
      :afterClose="afterClose"
      :title="null"
      :closable="false"
      :footer="null"
      width="595px"
      v-model="registerCard"
    >
      <a-spin :spinning="spinning">
        <div class="RegisterCard">
          <div class="title">
            <div class="name">- 注册电子健康卡 -</div>
            <div class="card-big">
              <icon-font type="icon-jiankang" />
            </div>
          </div>
          <div class="content">
            <div class="form-box">
              <a-form-model
                ref="ruleForm"
                :rules="rules"
                :model="form"
                @submit="handleSubmit"
                @submit.native.prevent
              >
                <a-form-model-item class="idCard" prop="name">
                  <a-input
                    placeholder-style="font-size: 20px;"
                    v-model="form.name"
                    placeholder="请输入姓名"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color:rgba(0,0,0,.25);font-size: 24px;"
                    />
                  </a-input>
                </a-form-model-item>
                <a-form-model-item class="idCard" prop="idCard">
                  <a-input
                    placeholder-style="font-size: 20px;"
                    v-model="form.idCard"
                    placeholder="请输入身份证号码"
                  >
                    <icon-font
                      slot="prefix"
                      type="icon-credentials_icon"
                      style="color:rgba(0,0,0,.25);font-size: 30px;"
                    />
                  </a-input>
                </a-form-model-item>
                <a-form-model-item
                  style="font-size: 20px;"
                  labelAlign="left"
                  :label-col="{ span: 2 }"
                  :wrapper-col="{ span: 21 }"
                  label="民族"
                  class="idCard"
                  prop="idCard"
                >
                  <a-select
                    placeholder="请选择民族"
                    v-model="form.nation"
                    style="width: 100%;font-size: 14px;height: 40px;"
                  >
                    <a-select-option
                      v-for="(item, index) in nations"
                      :key="index"
                      :value="item.value"
                    >{{ item.text }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item
                  style="font-size: 20px;"
                  labelAlign="left"
                  :label-col="{ span: 2 }"
                  :wrapper-col="{ span: 21 }"
                  label="关系"
                  class="idCard"
                  prop="relationShip"
                >
                  <a-select
                    placeholder="请选择关系"
                    v-model="form.relationShip"
                    style="width: 100%;font-size: 14px;height: 40px;"
                  >
                    <a-select-option
                      v-for="(item, index) in relationArr"
                      :key="index"
                      :value="item.value"
                    >{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item>
                  <a-button
                    class="sure-box cursor-point hp_center"
                    type="primary"
                    html-type="submit"
                  >绑定</a-button>
                </a-form-model-item>
              </a-form-model>
            </div>
            <div @click="openFast" class="fast-box cursor-point hp_sp_center">已有健康卡，快速绑卡</div>
            <div class="careful">
              <div>注意事项：</div>
              <div>1、支持本人及家属办卡</div>
            </div>
          </div>
          <Fast-bind ref="fastBind"></Fast-bind>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import FastBind from "@/components/FastBind";
import { getNations, fastRecord } from "@/api/user-center";
import { filter } from "@/api/cardfilter";
export default {
  components: {
    FastBind,
  },
  data() {
    return {
      fastBind: false,
      form: {
        fromType: "5",
        queryType: "1",
        name: "",
        idCard: "",
        nation: "汉族",
        relationShip: 0,
      },
      rules: {
        name: [],
      },
      registerCard: false,
      nations: [],
      relationArr: [
        {
          label: "本人",
          value: 0,
        },
        {
          label: "配偶",
          value: 1,
        },
        {
          label: "父母",
          value: 2,
        },
        {
          label: "子女",
          value: 3,
        },
        {
          label: "其他",
          value: 4,
        },
      ],
      spinning: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    afterClose() {
      this.form = {
        fromType: "5",
        queryType: "1",
        name: "",
        idCard: "",
        nation: "汉族",
        relationShip: 0,
      };
    },
    async init() {
      var res = await getNations();
      console.log("res==", res);
      this.nations = res.data;
      localStorage.setItem("nations", JSON.stringify(res.data));
    },
    getContainer() {
      return document.getElementsByClassName("RegisterCard")[0];
    },
    handleSubmit() {
      console.log(this.form);
      if (!this.form.name) {
        this.$message.warning("姓名未填写");
        return;
      }
      if (!this.form.idCard) {
        this.$message.warning("身份证未填写");
        return;
      }
      if (filter(this.form)) {
        this.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            this.spinning = true;
            var res = await fastRecord(this.form);
            console.log(res);
            this.spinning = false;
            if (res.code == 200) {
              this.$message.success("注册电子健康卡成功！");
            } else {
              this.$message.error(res.message);
            }
            this.$store
              .dispatch("setRelationRecords")
              .then(async () => {})
              .catch(() => {});
            this.onClose();
          }
        });
      } else {
        this.$message.warning("您已经注册过该身份证！,请勿重复注册");
        this.form.idCard = "";
      }
    },
    onClose() {
      this.registerCard = false;
    },
    onShow() {
      this.registerCard = true;
    },
    openFast() {
      this.$refs.fastBind.onShow();
      this.registerCard = false;
    },
    //判断是否已绑定过身份证
    userData() {},
  },
};
</script>
<style lang="less" scoped>
.RegisterCard {
  width: 100%;
  .title {
    width: 100%;
    height: 140px;
    background: url("~@/assets/user-center/regester-card.png") no-repeat center
      center;
    background-size: 100% 100%;
    padding-top: 73px;
    position: relative;
    .name {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
    }
    .card-big {
      width: 105px;
      height: 105px;
      border-radius: 50%;
      border: 4px solid #fff;
      background: #1779ff;
      font-size: 50px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -52px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content {
    padding: 25px;
    background: #fff;
    .sure-box {
      width: 100%;
      height: 78px;
      background: linear-gradient(90deg, #6fb2ff, #095fff);
      border-radius: 2px;
      letter-spacing: 10px;
      font-size: 31px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .fast-box {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #0f64ff;
      margin-top: 18px;
      margin-bottom: 45px;
    }
    .careful {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #999999;
    }
  }
}
.ant-form {
  width: 100%;
  .idCard {
    width: 100%;
    /deep/.ant-input {
      padding-left: 50px !important;
      font-size: 20px;
      height: 40px !important;
    }
  }
}
/deep/ .ant-modal-body {
  padding: 0;
}
input {
  text-indent: 4px;
}
/deep/.ant-form-item-label-left {
  label {
    font-size: 18px ;
  }
}
</style>
